export default __webpack_public_path__ + "static/linuxx-cabad1068c7b2d46657fb618dd7c2890.jpeg";